export default __webpack_public_path__ + "static/media/790651399461535805.1388e978.png";